// extracted by mini-css-extract-plugin
export var textarea = "textarea-module--textarea--I6E67";
export var textareaError = "textarea-module--textarea-error---7SB8";
export var textareaField = "textarea-module--textarea-field--vDVqJ";
export var textareaLabel = "textarea-module--textarea-label--Zf-px";